import * as React from 'react';

const DiscrepancyIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="189"
      height="208"
      viewBox="0 0 189 208"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="discrepancy-illustration"
    >
      <ellipse
        cx="104.899"
        cy="83.8342"
        rx="84.1005"
        ry="83.8342"
        fill="#F2F2F2"
      />
      <rect
        x="96"
        y="55"
        width="65.4357"
        height="13.9483"
        rx="6.97375"
        fill="white"
      />
      <path
        d="M35.9963 83H153.904C157.768 83 160.901 86.1224 160.901 89.9742C160.901 93.8259 157.768 96.9483 153.904 96.9483H35.9963C32.1324 96.9483 29 93.8259 29 89.9742C29 86.1224 32.1324 83 35.9963 83V83Z"
        fill="white"
      />
      <path
        d="M129.904 111C133.768 111 136.901 114.122 136.901 117.974C136.901 121.826 133.768 124.948 129.904 124.948H35.9963C32.1324 124.948 29 121.826 29 117.974C29 114.122 32.1324 111 35.9963 111L129.904 111Z"
        fill="white"
      />
      <path
        d="M37.4452 203.508L41.7646 203.508L43.8199 186.898L37.444 186.898L37.4452 203.508Z"
        fill="#A0616A"
      />
      <path
        d="M37.2928 208L50.5768 208V207.832C50.5766 204.986 48.2617 202.678 45.4063 202.678H45.4059L42.9795 200.843L38.4522 202.678L37.2926 202.678L37.2928 208H37.2928Z"
        fill="#202528"
      />
      <path
        d="M2.82629 191.581L6.28142 194.165L17.925 182.109L12.8249 178.295L2.82629 191.581Z"
        fill="#A0616A"
      />
      <path
        d="M0 195.083L10.6262 203.03L10.727 202.896C12.4405 200.619 11.978 197.388 9.69399 195.68L9.69374 195.68L8.85754 192.76L4.13124 191.52L3.20364 190.826L3.99945e-06 195.083L0 195.083Z"
        fill="#202528"
      />
      <path
        d="M17.1857 125.563C17.1857 125.563 17.4242 132.047 17.7249 137.247C17.7743 138.1 15.7699 139.026 15.8218 139.954C15.8563 140.57 16.233 141.168 16.268 141.81C16.305 142.487 15.7848 143.087 15.8218 143.787C15.858 144.472 16.4514 145.257 16.4872 145.957C16.8725 153.496 18.2688 162.521 16.8705 165.044C16.1814 166.287 7.39771 183.512 7.39771 183.512C7.39771 183.512 12.2917 190.83 13.69 188.391C15.5368 185.169 29.7703 170.096 29.7703 167.218C29.7703 164.343 33.0632 142.798 33.0632 142.798L35.3593 155.548L36.4121 158.074L36.0813 159.557L36.7617 161.559L36.7984 163.54L37.4608 167.218C37.4608 167.218 35.4683 195.876 36.5904 196.674C37.716 197.475 43.1658 198.914 43.809 197.475C44.4487 196.036 48.6127 167.567 48.6127 167.567C48.6127 167.567 49.2838 154.52 50.011 142.393C50.0529 141.69 50.5493 140.839 50.5878 140.146C50.6332 139.341 50.3186 138.296 50.3605 137.515C50.406 136.619 50.8045 135.989 50.8429 135.131C51.1401 128.507 49.4721 120.44 48.9408 119.646C47.3362 117.249 45.8925 115.332 45.8925 115.332C45.8925 115.332 24.2812 108.254 18.5063 115.446L17.1857 125.563L17.1857 125.563Z"
        fill="#040B2B"
      />
      <path
        d="M38.74 58.8843L30.1728 57.1763L26.1748 62.585C18.7148 69.897 18.6024 76.3504 19.9341 86.6947V101.213L18.9702 110.945C18.9702 110.945 15.5581 118.06 19.0774 119.716C22.5967 121.373 45.7132 121.231 47.9203 120.57C50.1273 119.909 48.2143 119.097 47.6347 116.016C46.546 110.227 47.2742 113.019 47.3491 111.176C48.4233 84.7383 45.9213 73.8846 45.6672 71.0317L41.3102 63.1543L38.74 58.8843Z"
        fill="#0F2658"
      />
      <path
        d="M83.8944 80.2006C83.0015 81.887 80.9062 82.5326 79.2145 81.6426C79.0341 81.5477 78.8624 81.4371 78.7016 81.3121L60.2 93.0225L60.2533 86.6467L78.2262 76.2497C79.5064 74.8189 81.7078 74.6936 83.1431 75.9697C84.3442 77.0375 84.6548 78.7867 83.8944 80.2006Z"
        fill="#A0616A"
      />
      <path
        d="M31.9758 66.268L29.8694 66.0455C27.9232 65.8443 26.0136 66.6752 24.8383 68.2347C24.3882 68.8261 24.0649 69.5035 23.8885 70.2247L23.8872 70.2305C23.3589 72.4014 24.1876 74.6766 25.9901 76.0038L33.2653 81.3505C38.3708 88.2273 47.9659 92.7897 59.2211 96.4963L76.7158 85.6655L70.5279 78.1949L58.5282 84.6055L40.6913 70.8416L40.681 70.8334L33.8922 66.4734L31.9758 66.268L31.9758 66.268Z"
        fill="#0F2658"
      />
      <ellipse
        cx="35.8453"
        cy="44.7318"
        rx="9.99056"
        ry="9.95892"
        fill="#A0616A"
      />
      <path
        d="M36.076 54.6929C35.9955 54.6955 35.9148 54.6973 35.8341 54.6995C35.7996 54.7887 35.7624 54.8772 35.7194 54.964L36.076 54.6928V54.6929Z"
        fill="#2F2E41"
      />
      <path
        d="M38.8178 45.008C38.8335 45.1062 38.8575 45.2028 38.8895 45.2969C38.8763 45.1983 38.8523 45.1014 38.8178 45.008Z"
        fill="#2F2E41"
      />
      <path
        d="M45.9633 35.199C45.5521 36.4718 45.1851 34.8572 43.8323 35.1476C42.205 35.497 40.3113 35.377 38.9786 34.3827C36.993 32.9304 34.4198 32.5394 32.0902 33.3361C29.8099 34.1403 25.9897 34.7073 25.3955 37.0445C25.189 37.857 25.107 38.7386 24.6064 39.412C24.1687 40.0007 23.4778 40.3363 22.9002 40.7894C20.9495 42.3193 22.4404 46.6658 23.3636 48.9625C24.2868 51.2591 26.4046 52.9322 28.733 53.7892C30.9858 54.6184 33.4309 54.7646 35.8341 54.6995C36.2522 53.6188 36.0716 52.3706 35.7267 51.2504C35.3533 50.0376 34.8004 48.8671 34.6444 47.608C34.4885 46.349 34.831 44.9188 35.89 44.2153C36.8635 43.5687 38.4476 43.9626 38.8179 45.0081C38.6018 43.701 39.93 42.4362 41.2996 42.2138C42.77 41.975 44.2404 42.5042 45.7065 42.7676C47.1727 43.031 46.6523 36.8779 45.9633 35.199Z"
        fill="#040B2B"
      />
      <ellipse
        cx="95.9873"
        cy="53.4335"
        rx="29.438"
        ry="29.4362"
        transform="rotate(-85.2688 95.9873 53.4335)"
        fill="#F55C38"
      />
      <path
        d="M104.497 41.59L96.6276 49.4607L88.758 41.59C87.4841 40.3159 85.4187 40.3159 84.1448 41.59C82.8709 42.8641 82.8709 44.9298 84.1448 46.2039L92.0144 54.0746L84.1448 61.9453C82.872 63.2206 82.874 65.2863 84.1491 66.5592C85.4225 67.8304 87.4846 67.8304 88.758 66.5592L96.6276 58.6885L104.497 66.5592C105.772 67.8321 107.838 67.8302 109.11 66.5549C110.381 65.2813 110.381 63.2189 109.11 61.9453L101.241 54.0746L109.11 46.2039C110.384 44.9298 110.384 42.8641 109.11 41.59C107.837 40.3159 105.771 40.3159 104.497 41.59V41.59Z"
        fill="white"
      />
      <path
        d="M73.4057 42.395C74.0084 44.2048 73.0251 46.1589 71.2096 46.7597C71.016 46.8237 70.8172 46.8706 70.6153 46.8998L66.2837 68.3156L61.7052 63.8632L66.6216 43.737C66.4722 41.8256 67.9055 40.1553 69.823 40.0064C71.4274 39.8817 72.9086 40.8692 73.4057 42.395H73.4057Z"
        fill="#A0616A"
      />
      <path
        d="M27.3766 70.0956L25.7573 71.4567C24.2642 72.7174 23.5437 74.6662 23.8589 76.5912C23.9754 77.3245 24.242 78.026 24.642 78.6522L24.6453 78.6571C25.851 80.5401 28.0717 81.5191 30.2804 81.1413L39.1875 79.6097C47.7002 80.6981 57.6456 76.9547 68.1208 71.4246L72.3921 51.3421L62.7002 50.6212L59.0334 63.691L36.7212 66.9927L36.7081 66.9943L28.852 68.8592L27.3766 70.0955L27.3766 70.0956Z"
        fill="#0F2658"
      />
    </svg>
  );
});

DiscrepancyIllustration.displayName = 'DiscrepancyIllustration';

export { DiscrepancyIllustration };
